export const testId = {
    notificationPayload: "notification-payload",
    btnClose: "btn-close"
} as const
